import type { CSSProperties } from "react";
import type { ShopHealth } from "../lib/types";

type Props = { days: number; health?: ShopHealth };

const colors: Record<string, CSSProperties> = {
  green:  { background: "rgba(0,232,122,0.15)", color: "#00E87A", border: "1px solid rgba(0,232,122,0.3)" },
  yellow: { background: "rgba(245,200,66,0.15)", color: "#f5c842", border: "1px solid rgba(245,200,66,0.3)" },
  red:    { background: "rgba(255,77,77,0.15)",  color: "#ff4d4d", border: "1px solid rgba(255,77,77,0.3)" },
};

function colorFromHealth(h: ShopHealth): string {
  if ("Critical" in h) return "red";
  if ("Low" in h) return "yellow";
  return "green";
}

export function StatusBadge({ days, health }: Props) {
  const color = health ? colorFromHealth(health) : days > 90 ? "green" : days > 30 ? "yellow" : "red";
  const label = isFinite(days) ? `${days}d left` : "∞";
  return (
    <span style={{
      ...colors[color],
      borderRadius: 4,
      padding: "2px 8px",
      fontSize: 12,
      fontWeight: 600,
      whiteSpace: "nowrap",
      fontFamily: "'DM Mono', monospace",
    }}>
      {label}
    </span>
  );
}
